import { useState, useEffect } from 'react'
import ApiService from '../data/services/ApiService'

const useContadorCheck = () => {
    const [esContador, setEsContador] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        let cancelled = false

        ApiService.getMiRol()
            .then(response => {
                if (!cancelled) {
                    setEsContador(Boolean(response?.data?.data?.esContador))
                    setLoading(false)
                }
            })
            .catch(() => {
                if (!cancelled) setLoading(false)
            })

        return () => { cancelled = true }
    }, [])

    return { esContador, loading }
}

export default useContadorCheck
